import { render, staticRenderFns } from "./activityDetails.vue?vue&type=template&id=aa219b5e&scoped=true"
import script from "./activityDetails.vue?vue&type=script&lang=js"
export * from "./activityDetails.vue?vue&type=script&lang=js"
import style0 from "./activityDetails.vue?vue&type=style&index=0&id=aa219b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa219b5e",
  null
  
)

export default component.exports